export const Colors = {
    primary: {
      blue:'#1D4F90',
      orange: '#E86316'
    },
    secondary: {
        blue: '#15284B',
        orange:'#C45130'
    }
}